export default __webpack_public_path__ + "static/Adelle-Bold-8a1a954a176f23155b36c94d8f806b75.woff2";